import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { LayoutBody, LayoutDoc } from "../../shared/layout";
import { api } from "../data/api";

export function useLayoutMutations() {
  const qc = useQueryClient();
  const upsert = (doc: LayoutDoc) =>
    qc.setQueryData<LayoutDoc[]>(["layouts"], (old) => {
      const list = old ?? [];
      return list.some((l) => l.id === doc.id) ? list.map((l) => (l.id === doc.id ? doc : l)) : [...list, doc];
    });
  return {
    save: useMutation({
      mutationFn: (v: { id: string; revision: number; name: string; body: LayoutBody }) =>
        api<LayoutDoc>(`/layouts/${v.id}`, { method: "PUT", body: { revision: v.revision, name: v.name, ...v.body } }),
      onSuccess: upsert,
    }),
    create: useMutation({
      mutationFn: (v: { name: string; copyFrom?: string; presetKey?: string }) => api<LayoutDoc>("/layouts", { method: "POST", body: v }),
      onSuccess: upsert,
    }),
    remove: useMutation({
      mutationFn: (id: string) => api<{ ok: true }>(`/layouts/${id}`, { method: "DELETE" }),
      onSuccess: (_r, id) => qc.setQueryData<LayoutDoc[]>(["layouts"], (old) => (old ?? []).filter((l) => l.id !== id)),
    }),
    refresh: () => qc.invalidateQueries({ queryKey: ["layouts"] }),
  };
}
